import { render, staticRenderFns } from "./OnboardSchoolDialog.vue?vue&type=template&id=566be18e"
import script from "./OnboardSchoolDialog.vue?vue&type=script&lang=js"
export * from "./OnboardSchoolDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports